import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelAccent(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--panelAccent', getDefaultPanelColors().panelAccent);
}
